/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-22 15:54:31
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-03-19 20:33:19
 * @FilePath: /knit-web/src/api/user.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';
import {
  User,
  UserListResponse,
  UserSearchParams,
  SSOUserInfo,
  SearchUserInfo,
} from '@/types/user';

// 获取当前用户信息
export const getUserInfoBySSOTokenApi = () => {
  return axios.get<{ found: boolean; user: User; sso_user_info: SSOUserInfo }>(
    '/api/console/user/v1/me/get'
  );
};

// 初始化新用户数据
export const initializeUserApi = () => {
  return axios.post('/api/console/tenant/v1/initialize');
};

// 获取用户工作空间列表
export const getUserWorkspacesApi = () => {
  return axios.get('/api/console/user/v1/workspaces/list');
};

// 搜索用户
export const searchUsersApi = (data: { email: string }) => {
  return axios.post<{ user: SearchUserInfo }>(
    '/api/console/user/v1/search',
    data
  );
};

// 更新当前用户信息
export const updateUserInfoApi = (data: { nickname?: string }) => {
  return axios.post<{ user: User }>('/api/console/user/v1/me/update', data);
};

export default {
  searchUsersApi,
  getUserInfoBySSOTokenApi,
  initializeUserApi,
  updateUserInfoApi,
};
